import { ReactNode } from "react";
import { ButtonVariant } from "../../types/button";
import { Link } from "react-router-dom";

const TargetTypes = {
    _blank: "_blank",
    _self: "_self"
} as const;
type TargetTypes = keyof typeof TargetTypes;

interface Props {
    to: string;
    variant: ButtonVariant;
    children: ReactNode;
    targetType?: TargetTypes;
    className?: string;
}

const ButtonLink = ({ to, variant, children, className = "", targetType = "_self" }: Props) => {
    return (
        <Link
            to={to}
            target={targetType}
            className={`px-4 py-1 transition-colors ${variant == ButtonVariant.PRIMARY
                    ? "rounded-full bg-[#008DD2] hover:bg-[#007CC1]"
                    : "text-[#008DD2] hover:text-[#007CC1]"
                } ${className}`}
        >
            {children}
        </Link>
    );
};
export default ButtonLink;
